import AdvancedBatchesGrid from "components/pages/newBatches/AdvancedBatchesGrid";
const AdvancedBatches = () => {
    return (
        <AdvancedBatchesGrid />
    );
};

export default AdvancedBatches;
